import {
  Banner,
  bannerTypes,
} from "./Banner.component";

export {Banner, bannerTypes};
